export default {
  ordersBreadcrumbTitle: {
    id: 'buyback_admin_order_orders',
    defaultMessage: 'Orders',
  },
  orderBreadcrumbTitle: {
    id: 'buyback_admin_order_order',
    defaultMessage: 'Order',
  },
  orderStatus: {
    id: 'buyback_admin_order_order_status_title',
    defaultMessage: 'Order Status',
  },
  counterOfferModalAssessment: {
    id: 'buyback_admin_order_co_assessment',
    defaultMessage: 'Refurbisher assessment',
  },
  counterOfferModalStaffAssessment: {
    id: 'buyback_admin_order_co_staff_assessment',
    defaultMessage: 'Agent assessment',
  },
  shippingLabelSuccessToastTitle: {
    id: 'buyback_admin_order_shipping_label_toast_title',
    defaultMessage: 'Shipping label created!',
  },
  submitCustomerInfoToastSuccessTitle: {
    id: 'buyback_admin_order_customer_update_success_toast_title',
    defaultMessage: 'Customer details have been updated!',
  },
  deleteCustomerInfoToastSuccessTitle: {
    id: 'buyback_admin_order_customer_delete_success_toast_title',
    defaultMessage: 'Customer details have been deleted!',
  },
  deleteCustomerSsnToastSuccessTitle: {
    id: 'buyback_admin_order_customer_delete_ssn_success_toast_title',
    defaultMessage: 'Client identity verification details have been deleted!',
  },
  deleteCustomerIDToastSuccessTitle: {
    id: 'buyback_admin_order_customer_delete_id_success_toast_title',
    defaultMessage: 'Client identity document(s) have been deleted!',
  },
  toastErrorBuybackInProgress: {
    id: 'buyback_admin_order_error_buyback_progress',
    defaultMessage:
      'You cannot delete this personal information: the user has a buyback in progress',
  },
  toastErrorShippingLabelTooManyRequests: {
    id: 'buyback_admin_order_error_shipping_label_too_many_requests',
    defaultMessage: 'Please wait 30 seconds between each generation attempt',
  },
  submitPaymentToastSuccessTitle: {
    id: 'buyback_admin_order_payment_success_toast_title',
    defaultMessage: 'Order has been payed!',
  },
  setOrderReceivedSuccessTitle: {
    id: 'buyback_admin_order_state_received_label_toast_title',
    defaultMessage: 'Order have been successfully set as received!',
  },
  setOrderSentSuccessTitle: {
    id: 'buyback_admin_order_state_sent_label_toast_title',
    defaultMessage: 'Order have been successfully set as sent!',
  },
  setPayoutEnabledSuccessTitle: {
    id: 'buyback_admin_order_payout_enabled_label_toast_title',
    defaultMessage: 'Order payout have been successfully enabled!',
  },
  setPayoutDisabledSuccessTitle: {
    id: 'buyback_admin_order_payout_disabled_label_toast_title',
    defaultMessage: 'Order payout have been successfully disabled!',
  },
  cancelOrderToastSuccessTitle: {
    id: 'buyback_admin_order_cancel_success_toast_title',
    defaultMessage: 'Order has been cancelled.',
  },
  orderClosed: {
    id: 'buyback_admin_order_status_closed',
    defaultMessage: 'Closed',
  },
}
